import { z } from 'zod/v4';

export const CompanyDocumentSchema = z.object({
  id: z.string(),
  companyId: z.string().nullable(),
  ownerCompanyId: z.string().nullable(),
  name: z.string(),
  documentTypeId: z.string().nullable(),
  fileId: z.string().nullable(),
  fileUrl: z.string().nullable(),
  originalFileUrl: z.string().nullable(),
  fileType: z.string().nullable(),
  fileContentType: z.string().nullable(),
  isPublic: z.union([z.boolean(), z.number()]).nullable(),
  type: z.string().nullable(),
  createdAt: z.coerce.date().nullable(),
  updatedAt: z.coerce.date().nullable(),
});

export type CompanyDocumentType = z.infer<typeof CompanyDocumentSchema>;
